import { Link } from 'react-router-dom';
import Logo from '../../assets/images/svg/Logo.svg';
import Fundzpe from '../../assets/images/fundz-pe-logo.png';
import BijayLogo from '../../assets/images/Bijaylogo.png';
import { BIJAY_CLIENT_ID } from './sidebar.config';

const FUNDZPE_CHANNEL_PARTNER_ID = '9b32c05c-1c12-4d49-a2dc-a93597275c2a';

// Reusing the tab favicon here so it matches the collapsed rail.
const MONK_ICON = `${process.env.PUBLIC_URL}/favicon.ico`;
const BIJAY_ICON = `${process.env.PUBLIC_URL}/bijay-favicon.ico`;

export default function SidebarLogo({ ctx, mode, onNavigate = () => {} }) {
  const isFundzpe = ctx.role === 'channel_user' && ctx.channelPartnerId === FUNDZPE_CHANNEL_PARTNER_ID;
  const isBijay = ctx.clientId === BIJAY_CLIENT_ID;
  const src = isFundzpe ? Fundzpe : isBijay ? BijayLogo : Logo;

  if (mode === 'collapsed') {
    return (
      <Link to="/" className="sidebar-logo sidebar-logo--collapsed" aria-label="Home" onClick={onNavigate}>
        <img src={isBijay ? BIJAY_ICON : MONK_ICON} alt="" className="sidebar-logo-icon" />
      </Link>
    );
  }

  return (
    <div className="sidebar-logo">
      <Link to="/" onClick={onNavigate}>
        <img src={src} alt="" className="sidebar-logo-image" />
      </Link>
      {isFundzpe && (
        <div className="sidebar-logo-powered-by">
          <span>POWERED BY</span>
          <img src={Logo} alt="" />
        </div>
      )}
    </div>
  );
}
